import React from 'react';
import devTeamStyling from "../styles/DevTeam.css"

const img = {
    _5thStepLightLogo: require("../Assets/Images/5th Step - Light Logo.png")
};

const members = {
    kiara: require("../Assets/Images/Member Icons/Kiara.png"),
    mudad: require("../Assets/Images/Member Icons/Artist/muda.png"),
    pg: require("../Assets/Images/Member Icons/Composers/pg.png"),
    max: require("../Assets/Images/Member Icons/Mappers/max.png"),
    tea: require("../Assets/Images/Member Icons/Composers/tea.jpg"),
    wirewolf: require("../Assets/Images/Member Icons/Composers/zesty.png"),
    demicore: require("../Assets/Images/Member Icons/Mappers/demicore.png"),
    ray: require("../Assets/Images/Member Icons/Media/ray.png"),
    skulltex: require("../Assets/Images/Member Icons/Mappers/Skully.png"),
}

export default function tutorialArchive() {
    return (
        <div className="about-frame">

            <div className="small-spacing">
                <img
                    src={img._5thStepLightLogo}
                    style={{height: "79px", width: "315px"}}
                    alt="Custom Menu.png!"
                />
                <h1 style={{color: "white"}}>WE MAKE VIDEO GAMES, SOMETIMES.</h1>
                <br></br><br></br>
                <p style={{color: "white"}}>We're a small indie studio, determined to bring you some pretty decent
                    games
                    to play. Poly Beats is our debut game, and from day 1, we've been proud to see it flourish, more
                    than we could ever imagine. Although we may not be the best studio on the planet, working
                    together
                    and collaborating on something awesome really makes the experience anyway.
                    <br></br><br></br>Each member of our team come from a unique background and harness their skill
                    to
                    make an awesome game, and drop it for the world to see. (This is what the "5" in our logos
                    represent. We all work from around 5 seperate regions of the world - and expanding hopefully.)
                    <br></br><br></br>Speaking of our members, why don't you say hi to each of them?
                </p>
                <br></br>
            </div>

            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.kiara}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Kiara (she/her){" "}
                        <span className="unity-developer">[Unity Developer]</span>{" "}
                        <span className="lead-modcharter">[Lead Modcharter]</span>{" "}
                        <span className="founder">[Founder]</span>
                    </p>
                    <p>Her name is always lowercase, but for the website it's gonna be capitalized correctly. This
                        is the girl who overarches quite a large portion of the studio. She's the founder, however
                        prefers to just stay around the Unity-Development-side of things.</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.pg}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>PG (any - prefers she/her){" "}
                        <span className="lead-composer">[Lead Composer]</span>{" "}
                        <span className="co-founder">[Co-Founder]</span>
                    </p>
                    <p>She's the co-founder of 5th Step, alongside the Lead Composer - in other words, she manages
                        some
                        of the music we funnel into Poly Beats, and also makes some banger chiptune tracks too.</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.max}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Max (he/him){" "}
                        <span className="lead-mapper">[Lead Mapper]</span>{" "}
                        <span className="media-manager">[Media Manager]</span>
                    </p>
                    <p>He manages things on the mapping side, gathering maps from his colleagues and organizing them
                        for
                        the Unity developers, and also makes the "Maximum" level charts for official Tune Packs. Try
                        beating one of bro's maps... 😭</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.mudad}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Mudad (she/her){" "}
                        <span className="lead-artist">[Lead Artist]</span>{" "}
                        <span className="locked">[<s>ROTCA ECIOV</s>]</span>
                    </p>
                    <p>She's the leader of everything art-y that doesn't have to do with in-game UI, and enjoys
                        taking
                        light inspiration from Genshin for hher character designs. :p</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.tea}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Tea Drinker (any){" "}
                        <span className="composer">[Composer]</span>{" "}
                    </p>
                    <p>They're a member of our composer team - and is pretty damn good at what they do. Although
                        they have a small catalog and likes to stay quiet, they're
                        still very talented and does carry.</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.wirewolf}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Wire Wolf (he/him){" "}
                        <span className="composer">[Composer]</span>{" "}
                    </p>
                    <p>He's another member of our composer team. Carries our catalog with the highly-energetic
                        tracks he
                        pumps out like it's nothing, and really brings a lot of vibrance to our OST.</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.demicore}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Demicore (he/him){" "}
                        <span className="mapper">[Mapper]</span>{" "}
                    </p>
                    <p>Demicore handles a lot on the mapping side. Weightlifts lower difficulties like it's light
                        work,
                        and really is a rainmaker when producing content updates.</p>
                </div>
            </div>
            <div className="dvt-leftright-textimage-align">
                <img
                    src={members.skulltex}
                    style={{height: "128px", width: "128px"}}
                    alt="Custom Menu.png!"
                />
                <div className="dvt-sectionFormatting">
                    <p>Skulltex (he/him or they/them){" "}
                        <span className="mapper">[Mapper]</span>{" "}
                    </p>
                    <p>Although our newest addition to 5th Step Games, he's still very helpful in terms of mapping,
                        alongside his very strategic suggestions that make the Quality Of Life inside Poly Beats far
                        better.</p>
                </div>
            </div>
        </div>
    );
}